import { render, staticRenderFns } from "./Runs.vue?vue&type=template&id=e6ad2380&lang=pug&"
import script from "./Runs.vue?vue&type=script&lang=ts&"
export * from "./Runs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports